import React, { useState } from "react";
import Header from '../component/Header.jsx';
import "../style/pages/ContactUs.css";
import facebookIcon from "../media3/contactus/fb.svg";
import instagramIcon from "../media3/contactus/insta.svg";
import twitterIcon from "../media3/contactus/twitter.svg";

const ContactUs = ({ isLoggedIn, setLoginModalOpen, handleLogout }) => {
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setMessage("✅ Thank you for contacting us! We'll get back to you soon.");
    e.target.reset(); // clears the form after submission
    setTimeout(() => setMessage(""), 4000); // message disappears after 4 sec
  };

  return (
    <>
  
      <section className="contact-section">
            <Header
        isLoggedIn={isLoggedIn}
        setLoginModalOpen={setLoginModalOpen}
        handleLogout={handleLogout}
      />
        
      <div className="contact-header">
        
        <p className="contact-subtitle">Get Started</p>
        <h1 className="contact-title">
          Get in touch with us. <br />
          We're here to assist you.
        </h1>
        {/* <button className="contact-btn">Contact Us</button> */}
      </div>

      {/* --- Social Links --- */}
      <div className="social-links">
        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
          <img src={facebookIcon} alt="Facebook" />
        </a>
        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
          <img src={instagramIcon} alt="Instagram" />
        </a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
          <img src={twitterIcon} alt="Twitter" />
        </a>
      </div>

      {/* --- Contact Form --- */}
      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="input-group">
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Email Address" required />
          <input type="text" placeholder="Phone Number (optional)" />
        </div>

        <textarea placeholder="Message" rows="4" required></textarea>

        <button type="submit" className="submit-btn">
          Leave us a Message →
        </button>

        {message && <p className="success-message">{message}</p>}
      </form>
    </section>
    </>
  );
};

export default ContactUs;
